var _circle, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloneDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 353,
    viewBox: "0 0 368 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 132,
    r: 27,
    fill: "#D11C1C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_415_4653)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 123,
    width: 88,
    height: 73,
    rx: 5,
    fill: "url(#paint0_linear_415_4653)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    y: 123.5,
    width: 87,
    height: 72,
    rx: 4.5,
    stroke: "url(#paint1_linear_415_4653)",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_4653)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_415_4653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.242 155.985C166.894 155.985 166.613 155.703 166.613 155.356C166.613 150.847 162.944 147.178 158.435 147.178C153.927 147.178 150.258 150.847 150.258 155.356C150.258 155.703 149.977 155.985 149.629 155.985C149.281 155.985 149 155.703 149 155.356C149 150.153 153.233 145.92 158.435 145.92C163.638 145.92 167.871 150.153 167.871 155.356C167.871 155.703 167.59 155.985 167.242 155.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.629 178C149.281 178 149 177.719 149 177.371V155.355C149 155.007 149.281 154.726 149.629 154.726C149.977 154.726 150.258 155.007 150.258 155.355V177.371C150.258 177.719 149.977 178 149.629 178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.24 178C166.893 178 166.611 177.719 166.611 177.371V155.355C166.611 155.007 166.893 154.726 167.24 154.726C167.588 154.726 167.869 155.007 167.869 155.355V177.371C167.869 177.719 167.588 178 167.24 178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.242 175.484H149.629C149.281 175.484 149 175.203 149 174.855C149 174.507 149.281 174.226 149.629 174.226H167.242C167.59 174.226 167.871 174.507 167.871 174.855C167.871 175.203 167.59 175.484 167.242 175.484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.242 178H149.629C149.281 178 149 177.719 149 177.371C149 177.023 149.281 176.742 149.629 176.742H167.242C167.59 176.742 167.871 177.023 167.871 177.371C167.871 177.719 167.59 178 167.242 178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.321 154.099C159.973 154.099 159.692 153.818 159.692 153.47C159.692 152.776 159.127 152.211 158.432 152.211C157.738 152.211 157.173 152.776 157.173 153.47C157.173 153.818 156.892 154.099 156.544 154.099C156.196 154.099 155.915 153.818 155.915 153.47C155.915 152.082 157.044 150.953 158.432 150.953C159.821 150.953 160.95 152.082 160.95 153.47C160.95 153.818 160.669 154.099 160.321 154.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.431 156.614C157.044 156.614 155.915 155.486 155.915 154.098C155.915 153.75 156.196 153.469 156.544 153.469C156.892 153.469 157.173 153.75 157.173 154.098C157.173 154.792 157.737 155.356 158.431 155.356C159.125 155.356 159.689 154.792 159.689 154.098C159.689 153.75 159.97 153.469 160.318 153.469C160.666 153.469 160.947 153.75 160.947 154.098C160.947 155.486 159.819 156.614 158.431 156.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.544 154.727C156.196 154.727 155.915 154.445 155.915 154.098V153.469C155.915 153.121 156.196 152.84 156.544 152.84C156.892 152.84 157.173 153.121 157.173 153.469V154.098C157.173 154.445 156.892 154.727 156.544 154.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.319 154.727C159.971 154.727 159.69 154.445 159.69 154.098V153.469C159.69 153.121 159.971 152.84 160.319 152.84C160.667 152.84 160.948 153.121 160.948 153.469V154.098C160.948 154.445 160.667 154.727 160.319 154.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.174 157.873C156.827 157.873 156.545 157.591 156.545 157.244V155.502C156.545 155.155 156.827 154.873 157.174 154.873C157.522 154.873 157.803 155.155 157.803 155.502V157.244C157.803 157.591 157.522 157.873 157.174 157.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.691 157.872C159.343 157.872 159.062 157.591 159.062 157.243V155.504C159.062 155.156 159.343 154.874 159.691 154.874C160.038 154.874 160.32 155.156 160.32 155.504V157.243C160.32 157.591 160.038 157.872 159.691 157.872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.837 159.131C162.489 159.131 162.208 158.849 162.208 158.502C162.208 158.154 161.926 157.873 161.579 157.873C161.231 157.873 160.95 157.591 160.95 157.244C160.95 156.896 161.231 156.614 161.579 156.614C162.62 156.614 163.466 157.461 163.466 158.502C163.466 158.849 163.185 159.131 162.837 159.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.578 157.873H159.691C159.343 157.873 159.062 157.591 159.062 157.244C159.062 156.896 159.343 156.614 159.691 156.614H161.578C161.926 156.614 162.207 156.896 162.207 157.244C162.207 157.591 161.926 157.873 161.578 157.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.838 163.534C162.49 163.534 162.208 163.253 162.208 162.905V158.502C162.208 158.154 162.49 157.873 162.838 157.873C163.185 157.873 163.467 158.154 163.467 158.502V162.905C163.467 163.253 163.185 163.534 162.838 163.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.028 159.131C153.68 159.131 153.399 158.849 153.399 158.502C153.399 157.461 154.246 156.614 155.286 156.614C155.634 156.614 155.915 156.896 155.915 157.244C155.915 157.591 155.634 157.873 155.286 157.873C154.939 157.873 154.657 158.154 154.657 158.502C154.657 158.849 154.376 159.131 154.028 159.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.175 157.873H155.288C154.94 157.873 154.659 157.591 154.659 157.244C154.659 156.896 154.94 156.614 155.288 156.614H157.175C157.523 156.614 157.804 156.896 157.804 157.244C157.804 157.591 157.523 157.873 157.175 157.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.028 163.534C153.68 163.534 153.399 163.253 153.399 162.905V158.502C153.399 158.154 153.68 157.873 154.028 157.873C154.376 157.873 154.657 158.154 154.657 158.502V162.905C154.657 163.253 154.376 163.534 154.028 163.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.917 172.339C155.569 172.339 155.288 172.058 155.288 171.71V160.388C155.288 160.04 155.569 159.759 155.917 159.759C156.264 159.759 156.546 160.04 156.546 160.388V171.71C156.546 172.058 156.264 172.339 155.917 172.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.949 172.339C160.601 172.339 160.32 172.058 160.32 171.71V160.388C160.32 160.04 160.601 159.759 160.949 159.759C161.297 159.759 161.578 160.04 161.578 160.388V171.71C161.578 172.058 161.297 172.339 160.949 172.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.433 172.34C158.085 172.34 157.804 172.058 157.804 171.711V166.049C157.804 165.701 158.085 165.42 158.433 165.42C158.781 165.42 159.062 165.701 159.062 166.049V171.711C159.062 172.058 158.781 172.34 158.433 172.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.915 165.42C154.527 165.42 153.399 164.292 153.399 162.904C153.399 162.556 153.68 162.275 154.028 162.275C154.376 162.275 154.657 162.556 154.657 162.904C154.657 163.598 155.221 164.162 155.915 164.162C156.263 164.162 156.544 164.443 156.544 164.791C156.544 165.139 156.263 165.42 155.915 165.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.949 165.42C160.601 165.42 160.32 165.139 160.32 164.791C160.32 164.443 160.601 164.162 160.949 164.162C161.643 164.162 162.207 163.598 162.207 162.904C162.207 162.556 162.488 162.275 162.836 162.275C163.184 162.275 163.465 162.556 163.465 162.904C163.465 164.292 162.337 165.42 160.949 165.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.949 172.339H155.917C155.569 172.339 155.288 172.058 155.288 171.71C155.288 171.362 155.569 171.081 155.917 171.081H160.949C161.297 171.081 161.578 171.362 161.578 171.71C161.578 172.058 161.297 172.339 160.949 172.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.145 176.113C151.797 176.113 151.516 175.832 151.516 175.484V174.855C151.516 174.507 151.797 174.226 152.145 174.226C152.493 174.226 152.774 174.507 152.774 174.855V175.484C152.774 175.832 152.493 176.113 152.145 176.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.661 176.113C154.313 176.113 154.032 175.832 154.032 175.484V174.855C154.032 174.507 154.313 174.226 154.661 174.226C155.009 174.226 155.29 174.507 155.29 174.855V175.484C155.29 175.832 155.009 176.113 154.661 176.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.178 176.113C156.83 176.113 156.549 175.832 156.549 175.484V174.855C156.549 174.507 156.83 174.226 157.178 174.226C157.526 174.226 157.807 174.507 157.807 174.855V175.484C157.807 175.832 157.526 176.113 157.178 176.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.694 176.113C159.346 176.113 159.065 175.832 159.065 175.484V174.855C159.065 174.507 159.346 174.226 159.694 174.226C160.042 174.226 160.323 174.507 160.323 174.855V175.484C160.323 175.832 160.042 176.113 159.694 176.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.21 176.113C161.862 176.113 161.581 175.832 161.581 175.484V174.855C161.581 174.507 161.862 174.226 162.21 174.226C162.558 174.226 162.839 174.507 162.839 174.855V175.484C162.839 175.832 162.558 176.113 162.21 176.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.724 176.113C164.376 176.113 164.095 175.832 164.095 175.484V174.855C164.095 174.507 164.376 174.226 164.724 174.226C165.072 174.226 165.353 174.507 165.353 174.855V175.484C165.353 175.832 165.072 176.113 164.724 176.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.629 155.985C188.281 155.985 188 155.703 188 155.356C188 150.847 184.331 147.178 179.822 147.178C175.313 147.178 171.645 150.847 171.645 155.356C171.645 155.703 171.364 155.985 171.016 155.985C170.668 155.985 170.387 155.703 170.387 155.356C170.387 150.153 174.619 145.92 179.822 145.92C185.025 145.92 189.258 150.153 189.258 155.356C189.258 155.703 188.977 155.985 188.629 155.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.016 178C170.668 178 170.387 177.719 170.387 177.371V155.355C170.387 155.007 170.668 154.726 171.016 154.726C171.364 154.726 171.645 155.007 171.645 155.355V177.371C171.645 177.719 171.364 178 171.016 178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.628 178C188.28 178 187.999 177.719 187.999 177.371V155.355C187.999 155.007 188.28 154.726 188.628 154.726C188.975 154.726 189.257 155.007 189.257 155.355V177.371C189.257 177.719 188.975 178 188.628 178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.629 175.484H171.016C170.668 175.484 170.387 175.203 170.387 174.855C170.387 174.507 170.668 174.226 171.016 174.226H188.629C188.977 174.226 189.258 174.507 189.258 174.855C189.258 175.203 188.977 175.484 188.629 175.484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.629 178H171.016C170.668 178 170.387 177.719 170.387 177.371C170.387 177.023 170.668 176.742 171.016 176.742H188.629C188.977 176.742 189.258 177.023 189.258 177.371C189.258 177.719 188.977 178 188.629 178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.708 154.099C181.36 154.099 181.079 153.818 181.079 153.47C181.079 152.776 180.514 152.211 179.82 152.211C179.125 152.211 178.56 152.776 178.56 153.47C178.56 153.818 178.279 154.099 177.931 154.099C177.583 154.099 177.302 153.818 177.302 153.47C177.302 152.082 178.431 150.953 179.82 150.953C181.208 150.953 182.337 152.082 182.337 153.47C182.337 153.818 182.056 154.099 181.708 154.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.821 156.614C178.433 156.614 177.305 155.486 177.305 154.098C177.305 153.75 177.586 153.469 177.934 153.469C178.282 153.469 178.563 153.75 178.563 154.098C178.563 154.792 179.127 155.356 179.821 155.356C180.515 155.356 181.079 154.792 181.079 154.098C181.079 153.75 181.36 153.469 181.708 153.469C182.056 153.469 182.337 153.75 182.337 154.098C182.337 155.486 181.208 156.614 179.821 156.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.931 154.727C177.583 154.727 177.302 154.445 177.302 154.098V153.469C177.302 153.121 177.583 152.84 177.931 152.84C178.279 152.84 178.56 153.121 178.56 153.469V154.098C178.56 154.445 178.279 154.727 177.931 154.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.708 154.727C181.36 154.727 181.079 154.445 181.079 154.098V153.469C181.079 153.121 181.36 152.84 181.708 152.84C182.056 152.84 182.337 153.121 182.337 153.469V154.098C182.337 154.445 182.056 154.727 181.708 154.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.564 157.873C178.216 157.873 177.935 157.591 177.935 157.244V155.502C177.935 155.155 178.216 154.873 178.564 154.873C178.912 154.873 179.193 155.155 179.193 155.502V157.244C179.193 157.591 178.912 157.873 178.564 157.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.08 157.872C180.732 157.872 180.451 157.591 180.451 157.243V155.504C180.451 155.156 180.732 154.874 181.08 154.874C181.428 154.874 181.709 155.156 181.709 155.504V157.243C181.709 157.591 181.428 157.872 181.08 157.872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.227 159.131C183.879 159.131 183.598 158.849 183.598 158.502C183.598 158.154 183.316 157.873 182.969 157.873C182.621 157.873 182.34 157.591 182.34 157.244C182.34 156.896 182.621 156.614 182.969 156.614C184.009 156.614 184.856 157.461 184.856 158.502C184.856 158.849 184.575 159.131 184.227 159.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.967 157.873H181.08C180.732 157.873 180.451 157.591 180.451 157.244C180.451 156.896 180.732 156.614 181.08 156.614H182.967C183.315 156.614 183.596 156.896 183.596 157.244C183.596 157.591 183.315 157.873 182.967 157.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.225 163.534C183.877 163.534 183.596 163.253 183.596 162.905V158.502C183.596 158.154 183.877 157.873 184.225 157.873C184.573 157.873 184.854 158.154 184.854 158.502V162.905C184.854 163.253 184.573 163.534 184.225 163.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.418 159.131C175.07 159.131 174.789 158.849 174.789 158.502C174.789 157.461 175.635 156.614 176.676 156.614C177.024 156.614 177.305 156.896 177.305 157.244C177.305 157.591 177.024 157.873 176.676 157.873C176.328 157.873 176.047 158.154 176.047 158.502C176.047 158.849 175.765 159.131 175.418 159.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.563 157.873H176.675C176.328 157.873 176.046 157.591 176.046 157.244C176.046 156.896 176.328 156.614 176.675 156.614H178.563C178.91 156.614 179.192 156.896 179.192 157.244C179.192 157.591 178.91 157.873 178.563 157.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.418 163.534C175.07 163.534 174.789 163.253 174.789 162.905V158.502C174.789 158.154 175.07 157.873 175.418 157.873C175.765 157.873 176.047 158.154 176.047 158.502V162.905C176.047 163.253 175.765 163.534 175.418 163.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.306 172.339C176.958 172.339 176.677 172.058 176.677 171.71V160.388C176.677 160.04 176.958 159.759 177.306 159.759C177.654 159.759 177.935 160.04 177.935 160.388V171.71C177.935 172.058 177.654 172.339 177.306 172.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.339 172.339C181.991 172.339 181.709 172.058 181.709 171.71V160.388C181.709 160.04 181.991 159.759 182.339 159.759C182.686 159.759 182.968 160.04 182.968 160.388V171.71C182.968 172.058 182.686 172.339 182.339 172.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.822 172.34C179.475 172.34 179.193 172.058 179.193 171.711V166.049C179.193 165.701 179.475 165.42 179.822 165.42C180.17 165.42 180.451 165.701 180.451 166.049V171.711C180.451 172.058 180.17 172.34 179.822 172.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.305 165.42C175.917 165.42 174.789 164.292 174.789 162.904C174.789 162.556 175.07 162.275 175.418 162.275C175.765 162.275 176.047 162.556 176.047 162.904C176.047 163.598 176.611 164.162 177.305 164.162C177.653 164.162 177.934 164.443 177.934 164.791C177.934 165.139 177.653 165.42 177.305 165.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.339 165.42C181.991 165.42 181.709 165.139 181.709 164.791C181.709 164.443 181.991 164.162 182.339 164.162C183.032 164.162 183.597 163.598 183.597 162.904C183.597 162.556 183.878 162.275 184.226 162.275C184.573 162.275 184.855 162.556 184.855 162.904C184.855 164.292 183.726 165.42 182.339 165.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.339 172.339H177.306C176.958 172.339 176.677 172.058 176.677 171.71C176.677 171.362 176.958 171.081 177.306 171.081H182.339C182.686 171.081 182.968 171.362 182.968 171.71C182.968 172.058 182.686 172.339 182.339 172.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.53 176.113C173.182 176.113 172.901 175.832 172.901 175.484V174.855C172.901 174.507 173.182 174.226 173.53 174.226C173.878 174.226 174.159 174.507 174.159 174.855V175.484C174.159 175.832 173.878 176.113 173.53 176.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.046 176.113C175.698 176.113 175.417 175.832 175.417 175.484V174.855C175.417 174.507 175.698 174.226 176.046 174.226C176.394 174.226 176.675 174.507 176.675 174.855V175.484C176.675 175.832 176.394 176.113 176.046 176.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.565 176.113C178.217 176.113 177.936 175.832 177.936 175.484V174.855C177.936 174.507 178.217 174.226 178.565 174.226C178.913 174.226 179.194 174.507 179.194 174.855V175.484C179.194 175.832 178.913 176.113 178.565 176.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.081 176.113C180.733 176.113 180.452 175.832 180.452 175.484V174.855C180.452 174.507 180.733 174.226 181.081 174.226C181.429 174.226 181.71 174.507 181.71 174.855V175.484C181.71 175.832 181.429 176.113 181.081 176.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.597 176.113C183.249 176.113 182.968 175.832 182.968 175.484V174.855C182.968 174.507 183.249 174.226 183.597 174.226C183.945 174.226 184.226 174.507 184.226 174.855V175.484C184.226 175.832 183.945 176.113 183.597 176.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.113 176.113C185.766 176.113 185.484 175.832 185.484 175.484V174.855C185.484 174.507 185.766 174.226 186.113 174.226C186.461 174.226 186.742 174.507 186.742 174.855V175.484C186.742 175.832 186.461 176.113 186.113 176.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.434 147.178C158.086 147.178 157.805 146.897 157.805 146.549V144.033C157.805 143.685 158.086 143.404 158.434 143.404C158.782 143.404 159.063 143.685 159.063 144.033V146.549C159.063 146.897 158.782 147.178 158.434 147.178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.434 144.66C158.086 144.66 157.805 144.379 157.805 144.031C157.805 142.297 159.216 140.886 160.95 140.886C161.298 140.886 161.579 141.167 161.579 141.515C161.579 141.863 161.298 142.144 160.95 142.144C159.909 142.144 159.063 142.991 159.063 144.031C159.063 144.379 158.782 144.66 158.434 144.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.822 147.178C179.475 147.178 179.193 146.897 179.193 146.549V144.033C179.193 143.685 179.475 143.404 179.822 143.404C180.17 143.404 180.451 143.685 180.451 144.033V146.549C180.451 146.897 180.17 147.178 179.822 147.178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.822 144.66C179.475 144.66 179.193 144.379 179.193 144.031C179.193 142.991 178.347 142.144 177.306 142.144C176.958 142.144 176.677 141.863 176.677 141.515C176.677 141.167 176.958 140.886 177.306 140.886C179.041 140.886 180.451 142.297 180.451 144.031C180.451 144.379 180.17 144.66 179.822 144.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.239 142.145C166.891 142.145 166.61 141.864 166.61 141.516C166.61 140.822 166.046 140.258 165.352 140.258C165.004 140.258 164.723 139.977 164.723 139.629C164.723 139.281 165.004 139 165.352 139C166.739 139 167.868 140.128 167.868 141.516C167.868 141.864 167.587 142.145 167.239 142.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.014 142.145C170.666 142.145 170.385 141.864 170.385 141.516C170.385 140.128 171.514 139 172.901 139C173.249 139 173.53 139.281 173.53 139.629C173.53 139.977 173.249 140.258 172.901 140.258C172.208 140.258 171.643 140.822 171.643 141.516C171.643 141.864 171.362 142.145 171.014 142.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.126 144.031C168.778 144.031 168.497 143.75 168.497 143.402C168.497 143.054 168.778 142.773 169.126 142.773C169.82 142.773 170.384 142.209 170.384 141.515C170.384 141.167 170.665 140.886 171.013 140.886C171.361 140.886 171.642 141.167 171.642 141.515C171.642 142.903 170.514 144.031 169.126 144.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.127 144.031C167.74 144.031 166.611 142.903 166.611 141.515C166.611 141.167 166.893 140.886 167.24 140.886C167.588 140.886 167.869 141.167 167.869 141.515C167.869 142.209 168.434 142.773 169.127 142.773C169.475 142.773 169.756 143.054 169.756 143.402C169.756 143.75 169.475 144.031 169.127 144.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.352 144.031C165.004 144.031 164.723 143.75 164.723 143.402C164.723 143.054 165.004 142.773 165.352 142.773C166.046 142.773 166.61 142.209 166.61 141.515C166.61 141.167 166.891 140.886 167.239 140.886C167.587 140.886 167.868 141.167 167.868 141.515C167.868 142.903 166.739 144.031 165.352 144.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.901 144.031C171.514 144.031 170.385 142.903 170.385 141.515C170.385 141.167 170.666 140.886 171.014 140.886C171.362 140.886 171.643 141.167 171.643 141.515C171.643 142.209 172.208 142.773 172.901 142.773C173.249 142.773 173.53 143.054 173.53 143.402C173.53 143.75 173.249 144.031 172.901 144.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.013 142.145C170.665 142.145 170.384 141.864 170.384 141.516C170.384 140.822 169.82 140.258 169.126 140.258C168.778 140.258 168.497 139.977 168.497 139.629C168.497 139.281 168.778 139 169.126 139C170.514 139 171.642 140.128 171.642 141.516C171.642 141.864 171.361 142.145 171.013 142.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.24 142.145C166.893 142.145 166.611 141.864 166.611 141.516C166.611 140.128 167.74 139 169.127 139C169.475 139 169.756 139.281 169.756 139.629C169.756 139.977 169.475 140.258 169.127 140.258C168.434 140.258 167.869 140.822 167.869 141.516C167.869 141.864 167.588 142.145 167.24 142.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.098 142.144H160.953C160.605 142.144 160.324 141.863 160.324 141.515C160.324 141.167 160.605 140.886 160.953 140.886H164.098C164.446 140.886 164.727 141.167 164.727 141.515C164.727 141.863 164.446 142.144 164.098 142.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.307 142.144H174.162C173.814 142.144 173.533 141.863 173.533 141.515C173.533 141.167 173.814 140.886 174.162 140.886H177.307C177.655 140.886 177.936 141.167 177.936 141.515C177.936 141.863 177.655 142.144 177.307 142.144Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_415_4653",
    x: 0,
    y: 0,
    width: 368,
    height: 353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_415_4653"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 15,
    dy: 17
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 70
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.109804 0 0 0 0 0.109804 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_415_4653",
    result: "effect2_dropShadow_415_4653"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_415_4653",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_415_4653",
    x: 145,
    y: 139,
    width: 48.2578,
    height: 47.0003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_415_4653"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_415_4653",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_4653",
    x1: 95.8244,
    y1: 53.3182,
    x2: 166.887,
    y2: 66.6775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBFB",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_415_4653",
    x1: 211.029,
    y1: 172.552,
    x2: 145.042,
    y2: 167.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_4653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(147 137)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneDark);
export default __webpack_public_path__ + "static/media/cloneDark.b7506e07b7d5fadfb921f9d7d8555862.svg";
export { ForwardRef as ReactComponent };